import axios from 'axios'
import { Upload } from 'element-ui'

const url = process.env.NODE_ENV === 'production' ? "/sunwebserver/api" : "/api"

//=================友情链接界面=================
//获取所有能显示的友情链接
const queryAllLinks = "/links/queryAllLinks"
//添加友链
const addLinks = "/links/addLinks"

//=================分类界面=================
//获取分类列表
const queryCategoryInfoList = "/category/queryCategoryInfoList"
//获取指定id的分类名称
const queryCategoryName = "/category/queryCategoryName"

//=================文章管理界面=================
//通过CategoryId获取文章数量
const queryArticleCount = "/article/queryArticleCount"
//文章列表获取
const queryArticleList = "/article/queryArticleList"
//所有文章列表获取
const queryAllArticleList = "/article/queryAllArticleList"
//获取指定id文章的内容
const queryArticleContent = "/article/queryArticleContent"

var urlManager = {
  QueryUrl: (api) => {
    return url + api;
  }
}

export default {
  //=================友情链接界面=================
  QueryAllLinks(cb) {
    axios.get(urlManager.QueryUrl(queryAllLinks))
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  },
  AddLinks(param, cb) {
    axios.post(urlManager.QueryUrl(addLinks), param)
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  },
  //=================分类界面=================
  QueryCategoryInfoList(cb) {
    axios.get(urlManager.QueryUrl(queryCategoryInfoList))
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  },
  QueryCategoryName(param, cb) {
    axios.get(urlManager.QueryUrl(queryCategoryName), param)
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  },
  //=================文章管理界面=================
  QueryArticleCount(param, cb) {
    axios.get(urlManager.QueryUrl(queryArticleCount), { params: { categoryIdArray: param } })
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  },
  QueryArticleList(param, cb) {
    axios.get(urlManager.QueryUrl(queryArticleList), { params: { categoryId: param.categoryId, page: param.page, searchParam: param.searchParam, isBlog: true } })
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  },
  QueryArticleContent(param, cb) {
    axios.get(urlManager.QueryUrl(queryArticleContent), { params: { id: param } })
      .then(cb)
      .catch(error => {
        console.log(error);
      });
  }
}